import {
  Box,
  FormControlLabel,
  Checkbox,
  Typography,
} from '@mui/material';
import type { EmailPreferences } from '../../types';

interface EmailPreferencesFormProps {
  preferences: EmailPreferences;
  onChange: (preferences: EmailPreferences) => void;
  disabled?: boolean;
}

export function EmailPreferencesForm({
  preferences,
  onChange,
  disabled,
}: EmailPreferencesFormProps) {
  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Email Preferences
      </Typography>

      <FormControlLabel
        control={
          <Checkbox
            checked={preferences.send_task_autoresponse_email}
            onChange={(e) =>
              onChange({ ...preferences, send_task_autoresponse_email: e.target.checked })
            }
            disabled={disabled}
          />
        }
        label="Send confirmation emails when tasks are submitted"
      />
    </Box>
  );
}
